<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">{{ title }}</h1>
			<p>{{ message }}</p>
		</div>

		<base-nav-links home no-back></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './components/BaseNavLinks';

	export default {
		name: "Error",

		components: {
			BaseNavLinks,
		},

		props: {
			title: {
				type: String,
				default: 'Error',
			},
			message: {
				type: String,
				default: 'Something went wrong, please try again',
			},
		},
	}
</script>

<style scoped>

</style>